/**
 * Class to manage loading and error in reducers
 */
export class LoadingGroup {

    private loaded: boolean;
    private loading: boolean;
    private error: object | null;

    /**
     * Init a loading object
     * @param loaded loaded indicator
     * @param loading loading indicator
     * @param error an error object
     */
    constructor(loaded = false, loading = false, error: object | null = null) {
        this.loaded = loaded;
        this.loading = loading;
        this.error = error;
    }

    /**
     * Start a loading
     */
    public start() {
        return new LoadingGroup(false, true, null);
    }

    /**
     * A loading successed
     */
    public success() {
        return new LoadingGroup(true, false, null);
    }

    /**
     * A loading failed
     * @param e an error
     */
    public fail(e: object | null) {
        return new LoadingGroup(false, false, e);
    }

    /**
     * Return true if it's started
     */
    public isStarted() {
        return !this.loaded && this.loading && this.error === null;
    }

    /**
     * Return true if it's successed
     */
    public isSuccessed() {
        return this.loaded && !this.loading && this.error === null;
    }

    /**
     * Return true if it's failed
     */
    public isFailed() {
        return !this.loaded && !this.loading && this.error !== null;
    }

    /**
     * Return the error object
     */
    public getError() {
        return this.error;
    }


}
